import React, { FC, createContext, useContext } from 'react';
import { DropdownNavigation } from 'app/components/header/navigation/DropdownNavigation';
import { DrawerNavigation } from 'app/components/header/navigation/DrawerNavigation';

/**
 * This enum specifies which navigation is currently, which type of navigation item
 * (or link or section) to render, and in what context a navigation item is being rendered.
 */
export const enum NavigationType {
  /**
   * Sidenav type navigation
   */
  Drawer,
  /**
   * **ANY** dropdown displayed in the header, not only the burger menu one.
   */
  Dropdown,
  /**
   * Signifies that an item is displayed in the header directly, instead of in a drawer or a dropdown.
   */
  Header,
}

/**
 * This context and the underlying hook should preferably be used inside Navigation items and not elsewhere.
 */
export const NavigationContext = createContext<{ type: NavigationType } | undefined>(undefined);
export const useNavigationContext = () => useContext(NavigationContext);

/**
 * The main navigation component which renders a burger menu and a specialized navigation (drawer or dropdown)
 * depending on the type provided. Renders null when type is set to NavigationType.Header.
 */
const Navigation: FC<{ type: NavigationType }> = ({ type, children }) => {
  switch (type) {
    case NavigationType.Drawer:
      return <DrawerNavigation>{children}</DrawerNavigation>;
    case NavigationType.Dropdown:
      return <DropdownNavigation>{children}</DropdownNavigation>;
    case NavigationType.Header:
      // Basically it doesn't make sense to render anything if the only navigation we want is the Header nav.
      // In his case NavigationType.Header === None.
      return null;
  }
};

export default Navigation;
